<template>
  <b-card-text>
    <b-row class="mb-3">
      <b-col>
        <button
          :disabled="disabled"
          @click="requestTerminalFromBehpardakht"
          class="btn btn-primary"
        >
          درخواست درگاه از به پرداخت ملت
        </button>

        <button
          :disabled="disabled"
          @click="requestTerminalForPerfect"
          class="btn btn-warning ml-2"
        >
          ایجاد درگاه پرفکت مانی
        </button>

        <button
          :disabled="disabled"
          @click="requestTerminalForStipe"
          class="btn btn-warning ml-2"
        >
          ایجاد درگاه استرایپ
        </button>

        <button
          :disabled="disabled"
          @click="requestTerminalForGPayment"
          class="btn btn-warning ml-2"
        >
          ایجاد درگاه GPayment
        </button>

        <button
          :disabled="disabled"
          @click="requestTerminalForSTP"
          class="btn btn-warning ml-2"
        >
          ایجاد درگاه SPT
        </button>
      </b-col>
    </b-row>
    <list-table
      :url="transactions.url"
      title="درگاه ها"
      :fields="transactions.fields"
      :params="transactions.params"
      :btns="transactions.btns"
    ></list-table>
    <b-modal
      id="edit_gateway"
      title="ویرایش درگاه"
      ok-title="ذخیره"
      cancel-title="انصراف"
      @ok="save"
    >
      <b-row>
        <b-col>
          <b-form-group label="بانک:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.bank_name"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="ترمینال:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.terminal_id"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="نام کاربری:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.username"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="رمز عبور:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.password"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="ترتیب:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.order"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="درگاه اصلی">
            <b-form-checkbox
              class="mt-2"
              v-model="gateway_acceptor.is_default"
            ></b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="کد پذیرنده:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.acceptorCode"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="iin:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.iin"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="درصد کارمزد:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.wage_percent"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="کارمزد ثابت:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.wage_static"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="حداکثر کارمزد:">
            <b-form-input
              id="input-1"
              v-model="gateway_acceptor.wage_max"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="sattle کردن خودکار">
            <b-form-checkbox
              class="mt-2"
              v-model="gateway_acceptor.auto_sattle"
            ></b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <date-picker
            v-model="gateway_acceptor.confirm_date"
            clearable
          ></date-picker>
        </b-col>
      </b-row>
    </b-modal>
  </b-card-text>
</template>

<script>
import moment from "jalali-moment";
import TableShowData from "../../components/table";
import httpHelper from "../../helpers/httpHelper";
export default {
  name: "gatewayacceptors",
  data() {
    return {
      disabled: false,
      gateway_acceptor: {},
      transactions: {
        url: "paymentgatewayacceptors/" + this.$route.params.id,
        detailCallFunType: "id",
        detailCallFun: "ShowDetail",
        fields: [
          //   {
          //     key: "id",
          //     label: "شماره درگاه",
          //   },
          {
            key: "bank_name",
            label: "بانک / درگاه",
          },
          {
            key: "terminal_id",
            label: "کد ترمینال",
          },
          {
            key: "username",
            label: "نام کاربری",
          },
          {
            key: "password",
            label: "رمز عبور",
          },
          {
            key: "iin",
            label: "iin",
          },
          {
            key: "wage_percent",
            label: "درصد کارمزد",
            formatter(value, key, item) {
              return value + " %";
            },
          },
          {
            key: "wage_max",
            label: "حداکثر کارمزد",
            formatter(value, key, item) {
              return Number(value).toLocaleString() + " ﷼";
            },
          },
          {
            key: "btns",
            label: "جزییات",
          },
        ],
        params: [],
        btns: [
          {
            title: "ویرایش",
            icon: "eye",
            handler: (t) => {
              httpHelper
                .getData("paymentgatewayacceptors/select/" + t.id)
                .then((res) => {
                  this.gateway_acceptor = res.result;
                  this.gateway_acceptor.auto_sattle =
                    this.gateway_acceptor.auto_sattle == 1;
                  this.gateway_acceptor.is_default =
                    this.gateway_acceptor.is_default == 1;
                  if (this.gateway_acceptor.confirm_date) {
                    this.gateway_acceptor.confirm_date = moment(
                      this.gateway_acceptor.confirm_date
                    ).format("jYYYY/jMM/jDD");
                  }
                  this.$bvModal.show("edit_gateway");
                });
            },
          },
          {
            title: "درخواست از شاپرک",
            icon: "eye",
            handler: (t) => {
              httpHelper
                .getData(
                  "shaparak/v2/requestTerminalFromShaparak/" +
                    this.$route.params.id +
                    "/" +
                    t.id
                )
                .then((res) => {
                  this.transactions.url =
                    "paymentgatewayacceptors/" +
                    this.$route.params.id +
                    "?t=" +
                    new Date().getTime();
                });
            },
          },
        ],
      },
    };
  },
  components: {
    "list-table": TableShowData,
  },
  methods: {
    requestTerminalForPerfect() {
      var data = {
        acceptorCode: new Date().getTime(),
        gateway_id: this.$route.params.id,
        terminal_id: "U30026461",
        username: new Date().getTime(),
        password: new Date().getTime(),
        order: 0,
        is_default: false,
        bank_name: "perfectmoney",
        wage_percent: 12,
        wage_max: 0,
        wage_static: 0,
        iin: "perfectmoney",
        confirm_date: null,
        auto_sattle: true,
        confirm_date: moment().format("jYYYY/jMM/jDD"),
      };
      httpHelper.postData("paymentgatewayacceptors", data).then((res) => {
        this.refreshTable();
      });
    },
    requestTerminalForStipe() {
      var data = {
        acceptorCode: new Date().getTime(),
        gateway_id: this.$route.params.id,
        terminal_id: "U30026461",
        username: new Date().getTime(),
        password: new Date().getTime(),
        order: 0,
        is_default: false,
        bank_name: "stripe",
        wage_percent: 12,
        wage_max: 0,
        wage_static: 0,
        iin: "stripe",
        confirm_date: null,
        auto_sattle: true,
        confirm_date: moment().format("jYYYY/jMM/jDD"),
      };
      httpHelper.postData("paymentgatewayacceptors", data).then((res) => {
        this.refreshTable();
      });
    },
    requestTerminalForGPayment() {
      var data = {
        acceptorCode: new Date().getTime(),
        gateway_id: this.$route.params.id,
        terminal_id: "U30026461",
        username: new Date().getTime(),
        password: new Date().getTime(),
        order: 0,
        is_default: false,
        bank_name: "gpayment",
        wage_percent: 12,
        wage_max: 0,
        wage_static: 0,
        iin: "gpayment",
        confirm_date: null,
        auto_sattle: true,
        confirm_date: moment().format("jYYYY/jMM/jDD"),
      };
      httpHelper.postData("paymentgatewayacceptors", data).then((res) => {
        this.refreshTable();
      });
    },
    requestTerminalForSTP() {
      var data = {
        acceptorCode: new Date().getTime(),
        gateway_id: this.$route.params.id,
        terminal_id: "U30026461",
        username: new Date().getTime(),
        password: new Date().getTime(),
        order: 0,
        is_default: false,
        bank_name: "stp",
        wage_percent: 12,
        wage_max: 0,
        wage_static: 0,
        iin: "stp",
        confirm_date: null,
        auto_sattle: true,
        confirm_date: moment().format("jYYYY/jMM/jDD"),
      };
      httpHelper.postData("paymentgatewayacceptors", data).then((res) => {
        this.refreshTable();
      });
    },
    refreshTable() {
      this.transactions.url =
        "paymentgatewayacceptors/" +
        this.$route.params.id +
        "?t=" +
        new Date().getTime();
    },
    requestTerminalFromBehpardakht() {
      httpHelper
        .postData("MerchantRequest", {
          id: this.$route.params.id,
          state: 2,
          gateway_acceptor_id: null,
        })
        .then((res) => {
          this.refreshTable();
        });
    },
    save(event) {
      event.preventDefault();
      httpHelper
        .postData("paymentgatewayacceptors", this.gateway_acceptor)
        .then((res) => {
          this.gateway_acceptor = {};
          this.$bvModal.hide("edit_gateway");
          this.transactions.url =
            "/paymentgatewayacceptors/" +
            this.$route.params.id +
            "?t=" +
            new Date().getTime();
        });
    },
  },
};
</script>